class CartDrawer extends HTMLElement {
    constructor() {
        super(), this.addEventListener("keyup", (e) => "Escape" === e.code && this.close()), this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)), this.setHeaderCartIconAccessibility();
    }
    setHeaderCartIconAccessibility() {
        let e = document.querySelector("#cart-icon-bubble");
        e.setAttribute("role", "button"),
            e.setAttribute("aria-haspopup", "dialog"),
            e.addEventListener("click", (t) => {
                t.preventDefault(), this.open(e);
            }),
            e.addEventListener("keydown", (t) => {
                "SPACE" === t.code.toUpperCase() && (t.preventDefault(), this.open(e));
            });
    }
    async open(e) {
  // 1. Set the active element immediately for focus returning
  if (e) {
    this.setActiveElement(e);
  }

  // 2. Do accessibility checks
  let summary = this.querySelector('[id^="Details-"] summary');
  if (summary && !summary.hasAttribute("role")) {
    this.setSummaryAccessibility(summary);
  }

  // 3. Prevent page scrolling
  document.body.classList.add("overflow-hidden");

  // 4. Add the 'animate' class first to prepare for the transition
  this.classList.add("animate");

  // 5. Use a Promise to wait for the next "paint" cycle before adding 'active'
  // This is a modern, reliable replacement for setTimeout(..., 0)
  await new Promise(requestAnimationFrame);

  this.classList.add("active");

  // 6. Use another Promise to wait for the transition to end
  await new Promise(resolve => {
    this.addEventListener("transitionend", resolve, { once: true });
  });

  // 7. Now that the drawer is fully open and stable, trap the focus
  const trapFocusEl = this.classList.contains("is-empty") 
    ? this.querySelector(".drawer__inner-empty") 
    : document.getElementById("CartDrawer");
  const closeButton = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
  trapFocus(trapFocusEl, closeButton);
}
    close() {
        this.classList.remove("active"), removeTrapFocus(this.activeElement), document.body.classList.remove("overflow-hidden");
    }
    setSummaryAccessibility(e) {
        e.setAttribute("role", "button"),
            e.setAttribute("aria-expanded", "false"),
            e.nextElementSibling.getAttribute("id") && e.setAttribute("aria-controls", e.nextElementSibling.id),
            e.addEventListener("click", (e) => {
                e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"));
            }),
            e.parentElement.addEventListener("keyup", onKeyUpEscape);
    }
    renderContents(e) {
        this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty"),
            (this.productId = e.id),
            this.getSectionsToRender().forEach((t) => {
                let r = t.selector ? document.querySelector(t.selector) : document.getElementById(t.id);
                r.innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector);
            }),
            setTimeout(() => {
                this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)), this.open();
            });
    }
    getSectionInnerHTML(e, t = ".shopify-section") {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
    getSectionsToRender() {
        return [{ id: "cart-drawer", selector: "#CartDrawer" }, { id: "cart-icon-bubble" }];
    }
    getSectionDOM(e, t = ".shopify-section") {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t);
    }
    setActiveElement(e) {
        this.activeElement = e;
    }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
            { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
        ];
    }
}
customElements.define("cart-drawer-items", CartDrawerItems);

(function () {
  // Helper to dynamically isolate elements relative to the clicked button/container [2]
  function getContextualCartElements(triggerEl) {
    const container = triggerEl
      ? triggerEl.closest('.cart-drawer__footer') ||
        triggerEl.closest('.drawer__footer') ||
        triggerEl.closest('.cart__footer') ||
        triggerEl.closest('.cart__blocks') ||
        triggerEl.closest('#CartDrawer') ||
        triggerEl.closest('cart-drawer') ||
        triggerEl.closest('form#cart') ||
        triggerEl.closest('section')
      : null;

    const root = container || document;

    return {
      checkbox: root.querySelector('#cart-delivery-terms-checkbox, .cart-disclosure-checkbox'),
      wrapper: root.querySelector('#cart-disclosure-wrapper, .cart-disclosure-box'),
      errorMsg: root.querySelector('#cart-terms-error, .cart-terms-error-msg'),
    };
  }

  // 1. Delegated Change Listener: Syncs state across ALL checkboxes & updates Shopify Cart API
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.id === 'cart-delivery-terms-checkbox' || e.target.classList.contains('cart-disclosure-checkbox'))) {
      const isChecked = e.target.checked;

      // Sync checkbox state across BOTH Main Cart and Cart Drawer elements
      const allCheckboxes = document.querySelectorAll('#cart-delivery-terms-checkbox, .cart-disclosure-checkbox');
      allCheckboxes.forEach((cb) => {
        cb.checked = isChecked;
      });

      // Clear validation errors on all active wrappers
      const allWrappers = document.querySelectorAll('#cart-disclosure-wrapper, .cart-disclosure-box');
      allWrappers.forEach((wrapper) => {
        if (isChecked) {
          wrapper.classList.remove('is-invalid');
          const err = wrapper.querySelector('#cart-terms-error, .cart-terms-error-msg');
          if (err) err.style.display = 'none';
        }
      });

      if (isChecked) {
        // Sync attribute record with Shopify Order Admin details
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Delivery Terms Accepted': 'Yes' } }),
        }).catch(function (err) {
          console.warn('LowCostAT: Cart attribute update error:', err);
        });
      }
    }
  });

  // 2. Capturing Click Interceptor with Relative Element Scoping [2]
  document.addEventListener(
    'click',
    function (e) {
      // Target real checkout triggers ONLY
      const checkoutBtn = e.target.closest(
        'button[name="checkout"], #checkout, #CartDrawer-Checkout, button[onclick*="request-quote"], button[onclick*="/apps/"], a[href*="/checkout"], a[href*="/apps/request-quote"]'
      );

      // EXCLUSIONS: Ignore "View My Cart", "Continue Shopping", or navigation links
      const isNavigationLink =
        e.target.closest('.view_cartdrawer') ||
        e.target.closest('a[href*="/cart"]') ||
        e.target.closest('a[href*="history.back"]') ||
        e.target.closest('a[href*="javascript:"]');

      if (checkoutBtn && !isNavigationLink) {
        // Isolate the specific checkbox, wrapper, and error message adjacent to the clicked button [2]
        const contextual = getContextualCartElements(checkoutBtn);
        const checkbox = contextual.checkbox;
        const wrapper = contextual.wrapper;
        const errorMsg = contextual.errorMsg;

        if (checkbox && !checkbox.checked) {
          // Halt inline onclick attributes & form submission immediately [2]
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          if (wrapper) {
            // FORCE DOM REFLOW: Resets CSS keyframe animation so it shakes on EVERY click attempt
            wrapper.classList.remove('is-invalid');
            void wrapper.offsetWidth; // Repaint trigger
            wrapper.classList.add('is-invalid');
          }

          if (errorMsg) errorMsg.style.display = 'block';

          checkbox.focus();
          if (wrapper) wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    },
    true // Capturing phase execution is mandatory
  );
})();